import { useState } from "react";
import { api, ApiError } from "../../lib/api";
import { toast } from "../../stores/toast";
import { Button } from "../ui";
import { StarRating } from "./StarRating";
import { ReviewPhotoUpload } from "./ReviewPhotoUpload";

export function PurchaseReviewForm({
  orderItemId,
  productName,
  onSubmitted,
}: {
  orderItemId: string;
  productName: string;
  onSubmitted: () => void;
}) {
  const [rating, setRating] = useState(5);
  const [comment, setComment] = useState("");
  const [images, setImages] = useState<string[]>([]);
  const [submitting, setSubmitting] = useState(false);

  async function submit() {
    if (rating < 1) {
      toast("error", "Choose a star rating");
      return;
    }
    setSubmitting(true);
    try {
      await api("/reviews", {
        method: "POST",
        body: {
          orderItemId,
          rating,
          comment: comment.trim() || undefined,
          images: images.length ? images : undefined,
        },
      });
      toast("success", "Review submitted");
      onSubmitted();
    } catch (err) {
      toast("error", err instanceof ApiError ? err.message : "Could not submit review");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="space-y-3 rounded-2xl border border-white/5 bg-surface p-4">
      <p className="text-xs font-semibold text-white">Review {productName}</p>
      <StarRating value={rating} onChange={setRating} />
      <label className="block space-y-1">
        <span className="text-[11px] font-medium text-white/60">Your review</span>
        <textarea
          rows={3}
          placeholder="Share your experience with this item…"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className="w-full rounded-xl border border-white/10 bg-surface-2 px-3 py-2.5 text-sm text-white outline-none placeholder:text-white/30 focus:border-brand-pink/50"
        />
      </label>
      <ReviewPhotoUpload value={images} onChange={setImages} />
      <Button className="w-full" disabled={submitting} onClick={() => void submit()}>
        Submit review
      </Button>
    </div>
  );
}
